import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Label, Row } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { getSalesOffice } from "helpers/UAM/salesoffice.helper"
import Breadcrumbs from "components/Common/BreadcrumbTitle"

const ViewSalesOffice = () => {
  document.title = "View Sales Office | DMS"
  const [salesOffice, setSalesOffice] = useState({})
  const urlParams = new URLSearchParams(window.location.search)
  const encodedId = urlParams.get("id")
  const decodedId = atob(encodedId)
  const navigate = useNavigate()

  useEffect(() => {
    getSalesOffice({ salesOfficeId: decodedId })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setSalesOffice(responseFromAPI.data)
        }
      })
      .catch(error => {})
  }, [])

  const handleCancel = () => {
    navigate(-1)
  }

  return (
    <div className="page-content">
      
      <div className="d-flex align-items-center justify-content-between px-2 mb-1">
        <div className="d-flex justify-content-start">
        <Breadcrumbs title="View Sales Office" breadcrumbItem="View Sales Office" />
        </div>
      </div>
      <Container fluid>
        <Card>
          <CardBody>
            <h5>Sales Office Details</h5>
            <Row>
              <Col xs="12" md="4">
                <div className="mb-3">
                  <Label className="form-label label-styling " >
                    Sales Office Name
                  </Label>
                  <p>{salesOffice.salesOfficeName}</p>
                </div>
              </Col>

              <Col xs="12" md="4">
                <div className="mb-3">
                  <Label className="form-label label-styling " >
                    Sales Office Code
                  </Label>
                  <p>{salesOffice.salesOfficeCode}</p>
                </div>
              </Col>

              <Col xs="12" md="4">
                <div className="mb-3">
                  <Label className="form-label label-styling " >
                    Email
                  </Label>
                  <p>{salesOffice.email}</p>
                </div>
              </Col>

              <Col xs="12" md="4">
                <div className="mb-3">
                  <Label className="form-label label-styling " >
                    Mobile
                  </Label>
                  <p>{salesOffice.mobileNo}</p>
                </div>
              </Col>

              {salesOffice?.userSalesOfficeMappings?.length > 0 && (
                <Col xs="12" md="4">
                  <div className="mb-3">
                    <Label className="form-label label-styling " >
                      Users
                    </Label>
                    <p>
                      {salesOffice.userSalesOfficeMappings
                        .map(
                          mapping =>
                            `${mapping.user.firstName} ${mapping.user.lastName}`
                        )
                        .reduce(
                          (unique, name) =>
                            unique.includes(name) ? unique : [...unique, name],
                          []
                        )
                        .join(", ")}
                    </p>
                  </div>
                </Col>
              )}
              {salesOffice?.dealerSalesOfficeMappings?.length > 0 && (
                <Col xs="12" md="4">
                  <div className="mb-3">
                    <Label className="form-label label-styling " >
                      Dealers
                    </Label>
                    <p>
                      {salesOffice.dealerSalesOfficeMappings
                        .map(mapping => mapping?.dealer?.entityName)
                        .reduce(
                          (unique, item) =>
                            unique.includes(item) ? unique : [...unique, item],
                          []
                        )
                        .join(", ")}
                    </p>
                  </div>
                </Col>
              )}
            </Row>

            <h5 className="mt-4">
              Address Details
            </h5>
            <Row>
              <Col xs="12" md="4">
                <div className="mb-3">
                  <Label className="form-label label-styling " >
                    Current Address
                  </Label>
                  <p>{salesOffice.address?.address1}</p>
                </div>
              </Col>

              <Col xs="12" md="4">
                <div className="mb-3">
                  <Label className="form-label label-styling " >
                    City
                  </Label>
                  <p>{salesOffice.address?.city}</p>
                </div>
              </Col>

              <Col xs="12" md="4">
                <div className="mb-3">
                  <Label className="form-label label-styling " >
                    State
                  </Label>
                  <p>{salesOffice.address?.state}</p>
                </div>
              </Col>

              <Col xs="12" md="4">
                <div className="mb-3">
                  <Label className="form-label label-styling " >
                    Pincode
                  </Label>
                  <p>{salesOffice.address?.pincode}</p>
                </div>
              </Col>
            </Row>
            <button
          className="btn btn-outline-secondary"
          type="button"
          onClick={handleCancel}
        >
          Back
        </button>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default ViewSalesOffice
